import { createSelector } from '@ngrx/store';
import { authFeature } from './auth.feature';

// Base selectors generated by createFeature.
export const {
  selectAuthState,
  selectUser,
  selectTenantId,
  selectStatus,
  selectError,
  selectRestored,
} = authFeature;

// Derived read models — components read the store only through selectors.
export const selectIsAuthenticated = createSelector(selectUser, (user) => user !== null);

export const selectUserEmail = createSelector(selectUser, (user) => user?.email ?? null);

export const selectIsAuthenticating = createSelector(
  selectStatus,
  (status) => status === 'authenticating',
);
